import { render, staticRenderFns } from "./AttachmentChips.vue?vue&type=template&id=864103d2&scoped=true"
import script from "./AttachmentChips.vue?vue&type=script&lang=js"
export * from "./AttachmentChips.vue?vue&type=script&lang=js"
import style0 from "./AttachmentChips.vue?vue&type=style&index=0&id=864103d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864103d2",
  null
  
)

export default component.exports